import React from 'react';
import { useCases } from '../data/mock';
import { Users, Heart, ShieldAlert, GraduationCap } from 'lucide-react';

const iconMap = {
  'users': Users,
  'user-heart': Heart,
  'shield-alert': ShieldAlert,
  'graduation-cap': GraduationCap
};

export const UseCases = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-teal-50 via-white to-emerald-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Built for Everyone
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Whether you're a family, friend group, or student — Fuzz keeps you connected
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {useCases.map((useCase, index) => {
            const Icon = iconMap[useCase.icon];
            const colors = [
              'from-teal-500 to-emerald-500',
              'from-emerald-500 to-green-500',
              'from-rose-500 to-orange-500',
              'from-blue-500 to-teal-500'
            ];
            
            return (
              <div 
                key={index} 
                className="group bg-white p-8 rounded-2xl border border-gray-200 hover:shadow-2xl transition-all hover:-translate-y-2"
              >
                {/* Icon with gradient */}
                <div className={`w-16 h-16 bg-gradient-to-br ${colors[index]} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                  <Icon className="h-8 w-8 text-white" />
                </div>
                
                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {useCase.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {useCase.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Scenarios */}
        <div className="mt-16 max-w-4xl mx-auto">
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-lg border border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Real-Life Scenarios</h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700"><span className="font-semibold">Friends in the same city</span> — discover who's nearby</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-emerald-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700"><span className="font-semibold">Parents tracking kids</span> — know they're in safe zones</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700"><span className="font-semibold">Couples traveling</span> — stay connected on adventures</p>
                </div>
              </div>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700"><span className="font-semibold">Students on campus</span> — meet up effortlessly</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-rose-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700"><span className="font-semibold">Emergency safety</span> — instant SOS for loved ones</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
